import { render } from "./MobileMoreMenu.vue?vue&type=template&id=15207ad3&scoped=true"
import script from "./MobileMoreMenu.vue?vue&type=script&lang=js"
export * from "./MobileMoreMenu.vue?vue&type=script&lang=js"

import "./MobileMoreMenu.vue?vue&type=style&index=0&id=15207ad3&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15207ad3"]])

export default __exports__